import angular from "angular";

import OrganisationOwnerSettingsModuleRouting from "./organisation-owner-settings.module.routing";

export default angular
  .module("vt-organisation-owner-settings", [])
  .config(OrganisationOwnerSettingsModuleRouting);
